import { ITenant } from "../app/models/tenant";
import { RootStoreContext } from "../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

// reactstrap components
import { Card, CardTitle, CardBody, Col, Row } from "reactstrap";
import InfoMessage from "./common/InfoMessage";
import TenantAccessButton from "./buttons/TenantAccessButton";
import TenantLogo from "./common/TenantLogo";
import Loader from "./common/Loader";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";

interface IProps {
  tenants: ITenant[];
}

const TenantListComponent: React.FC<IProps> = ({ tenants }) => {
  const rootStore = useContext(RootStoreContext);
  const { loadingInitial } = rootStore.tenantStore;
  const { companyTheme } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  const splitTenantsList = () => {
    let retList: ITenant[][] = [];

    let tempList: ITenant[] = [];
    tenants.forEach((t) => {
      if (t.featured) {
        if (tempList.length > 0) retList.push(tempList);
        retList.push([t]);
        tempList = [];
      } else tempList.push(t);
    });
    if (tempList.length > 0) retList.push(tempList);

    return retList;
  };

  if (tenants.length === 0)
    return (
      <InfoMessage
        message={t("contact_admin_text")}
        icon="fas fa-phone-square fa-3x"
      />
    );

  return (
    <>
      {loadingInitial ? (
        <Loader />
      ) : (
        <>
          {splitTenantsList().map((list, index) => (
            <Row key={`tenant_list_${index}`} className="justify-content-center w-100">
              {list.map((tenant) => (
                <Col xs={12} md={3} key={tenant.id} className="mb-4">
                  <Card>
                  <div className="logo_container">
                    <TenantLogo
                      tenant={tenant}
                      className="card-img-top tenant-card-img"
                    />
                    </div>
                    <CardBody>
                      {companyTheme!.displayTenantNameInTenantList && (
                        <Row>
                          <CardTitle className="text-center col-12">
                            <strong>{tenant.name}</strong>
                          </CardTitle>
                        </Row>
                      )}
                      <Row>
                        <TenantAccessButton tenant={tenant} />
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          ))}
        </>
      )}
    </>
  );
};

export default observer(TenantListComponent);
